import { isString } from 'lodash';
import { isValid, format } from '@fnando/cnpj';

export default (cnpj) => {
  if (!isString(cnpj) || !isValid(cnpj)) return '';
  return format(cnpj);
};
